import { render, staticRenderFns } from "./EventSnsPr.vue?vue&type=template&id=8e92ca5c&"
import script from "./EventSnsPr.vue?vue&type=script&lang=js&"
export * from "./EventSnsPr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports